module.exports = __webpack_public_path__ + "img/verified-email.ba384cc1.svg";